export const CSS = {
  heading: "heading",
  container: "container",
  indented: "container--indented",
};

export const SLOTS = {
  parentItem: "parent-item",
};
